var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaderOpen)?_c('div',{staticClass:"overlay-loader"},[_c('div',{staticClass:"cp-spinner cp-round",attrs:{"id":"loader"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }